import { get, writable } from 'svelte/store';

const { subscribe, set, update } = writable({});

const peers = createPeers({});

function createPeers(init) {
  set(init);

  return {
    set,
    subscribe,
    mergeUpdates,
    getClusterSize,
  };
}

/* ================================================================*/

function mergeUpdates(updates) {
  // console.log('mergeUpdates(updates):', updates);
  update((peers) => {
    const updatedPeers = { ...peers };
    for (let peerId in updates) {
      updatedPeers[peerId] = { ...updatedPeers[peerId], ...updates[peerId] };
    }
    return updatedPeers;
  });
}

function getClusterSize(clusterId) {
  const $peers = get(peers);
  let count = 0;
  for (let peerId in $peers) {
    if ($peers[peerId].clusterId == clusterId) count++;
  }
  // console.log('count:', count);
  return count;
}

export { peers };
